// Ant Design
import { Layout, theme } from 'antd';

// project import
import { drawerWidth } from '@/config';
import { collapsedWidth } from '../Drawer/MiniDrawerStyled';
import { useTheme } from '@/App';

const { Header } = Layout;

// ==============================|| HEADER - APP BAR STYLED ||============================== //

const AppBarStyled = ({ open, children, ...other }) => {
  const { isDark } = useTheme();
  const { token } = theme.useToken();
  const marginLeft = open ? drawerWidth : collapsedWidth;
  const width = `calc(100% - ${marginLeft}px)`;

  return (
    <Header
      {...other}
      className="fixed z-[1200] transition-all duration-300 ease-in-out"
      style={{
        marginLeft: `${marginLeft}px`,
        width,
        padding: 0,
        height: 64,
        lineHeight: '64px',
        background: isDark ? token.colorBgContainer : '#fff',
      }}
    >
      {children}
    </Header>
  );
};

export default AppBarStyled;
